// generated

import { CssBaseline, ThemeProvider, useTheme } from "@material-ui/core";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";
const Metadata: React.FC<{
  children: React.ReactNode;
}> = (props: { children: React.ReactNode }) => {
  const theme = useTheme();
  const ctx = useAppContext();
  const themeValue = React.useMemo(() => {
    const value = ((theme: any) => ({
      overrides: {
        MuiCssBaseline: {
          "@global": {
            ".Metadata .headerLeft": {
              display: "flex",
              alignItems: "center",
              justifyContent: "space-around",
            },
            ".Metadata .iconClose": {
              width: "60px",
              height: "60px",
              backgroundImage:
                "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAEAElEQVR4Ae2av27bMBCH89Qe8wYZs6Vb+gTplm5+g2RLt3RKN8t/JFuSWXxuaQiGdCSPpCTAJmDQsEXqfh+PxyOlO3Pl5e7K9ZsbgJsHXDmBUadA27bmcDiYsqrMdrczm83WrDcbs+Gz3ZrdrjT7/d7UTWOOx+MoQ5MVACIOh/oktijWZrUqgj7AqarKAC5XyQIAg8uyMhrRQ5DwkLquk3NICoARx72LImykh0T3/c60SQkiGQCMWq83QS7eJ9D3t11ZJokTSQAw6r6Gp7yOGNE0TdS0iAKAyxPNU4oK7Ys4w8qiLWoAiCcwhRqc5fqiUENQATiN/FzE26VVCUEFgIQly0haMcqa6RAaE4IBkKnNUby1icCIh/qWIABN22Zd462I2Jol0rcEAdjObd4LU8U3WfIGQIexIzNmezJGn+INgB3bmAJS3MvHC7wA1HWjEv/19ce8vPxQtbUAlsul+fj4peqDPMVVvADsFNke4h8eHsxisTDPz99VAhBP+/v7ezUE11baCYAlZaXY3XUBaCBY8bEAOE+QihNATPDTQkglnmlEXiAVJ4CyjMv6QiGkFG/jiJQYOQFA0HakrX0h5BCPzZwxDhUnAM387wPlgpBLPLaQvg8VEcApAArZVp9Q6bchCDnFYw+bt6EyKgCMuYTw+Ph4Wupio70EXsoHRACsoVLH2v8uIeQUj41ksUNlEgAY9fr68zzyAHh6+pYFNveSlsJJAHTnPOLtR5sxujxR2hiJAFIHQQztiifFfXt7P6fMgMgBgYPboSICoJGLbsj/l+LtJucyJqSGwLH9UHECKNbhz/T6oAyJt9fmhCAdmzsBpDgFconPDUHaEToBxB6C+orPBYGTYqk4AcTkAqHic0CQAiBgnAC4SPPQ8/Pz93l50xxoXMYEYFpAITXvJ0jFC0ClfBaA0RrxVqCFoF0VcH9pK+ztAXSifeaPCCtIU8e05yUNV/HyADqJPRjRiI9pw4BJ0d+C8QbQtnhBmpwgRphvWyn5seKpvQFwceyS6Gt87HUEbdfctxCCANAoRWIUK1BsXxRB7xAFA2BepUqPRSHKkyhf11d7AA1PR+WKZwU5BHf7dCU9VnS3DvYA25gNRqoD064I7Xempu+8txqo1QBoPBcIWvHRAOiA6TBlTODEVzPy2E6J8oD/fZwSjrFXBxId6bzf2uaqkwCwN8GgMZIlYDdNmheokwIABBkjabN27yAFQQ43D4lfmE4OwHoD85JdpGYr3YUASN5P8Hnbw947pM4GoGsEyRPTA9d1Bszi3zk+XoTomADXtWHo+ygA+m6OMMCcP8djdrF9dkwGoM+YKX67AZiC+pzuefOAOY3GFLbcPGAK6nO659V7wF9hTtl5X9G1/QAAAABJRU5ErkJggg==)",
              backgroundPosition: "0px 0px",
              backgroundRepeat: "no-repeat",
            },
          },
        },
      },
      qpr: {
        KPIDetailsContent: {
          ModalMetadata: {
            ...theme.qpr.KPIDetailsContent.Metadata,
            PropsArea: {
              css: {
                display: "flex",
                flexWrap: "wrap",
                gap: "5px",
                justifyContent: "space-between",
                [theme.breakpoints.down("xs")]: {
                  gap: "1px",
                },
              },
            },
            HeaderRow: {
              css: {
                display: "flex",
                justifyContent: "space-between",
                marginTop: "-20px",
                marginBotton: "50px",
              },
            },
            Header: {
              css: {
                fontFamily: "Ample",
              },
            },
            Prop: {
              css: {
                color: "red",
                minWidth: "150px",
                [theme.breakpoints.down("sm")]: {
                  minWidth: "100px",
                },
              },
            },
            ModalContainer: {
              css: {
                margin: "20px",
                height: "auto",
                overflow: "visible",
              },
            },
            Modal: {
              css: {
                background: "rgba(0,0,0,0.1)",
                display: "flex",
                justifyContent: "center",
                marginTop: "20px",
                [theme.breakpoints.down("sm")]: {
                  height: "95vh",
                },
              },
            },
            ModalPaper: {
              css: {
                overflow: "auto",
                background: "white",
                width: "80%",
                height: "auto !important",
                fontSize: 13,
                padding: "10px",
                margin: "30px",
                borderRadius: "20px",
                [theme.breakpoints.down("sm")]: {
                  width: "95vw",
                  margin: "10px",
                  fontSize: 12,
                },
                [theme.breakpoints.down("xs")]: {
                  width: "95vw",
                  margin: "10px",
                  fontSize: 9,
                },
                [theme.breakpoints.up("lg")]: {
                  fontSize: 14,
                },
              },
            },
          },

          Metadata: {
            ...theme.qpr.KPIDetailsContent.Metadata,
            More: {
              css: {
                color: "rgb(0,167,165)",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
              },
            },
          },
          KPIDetailsMetadataContainer: {
            css: {
              background: "rgb(250,250,250)",
              padding: "10px",
              borderRadius: "26px",
              gridColumn: "3",
              gridRow: "2",
              marginTop: "5px",
              // marginLeft:'30px',
              fontSize: "14px",
            },
          },
        },
      },
    }))(theme);
    (value as any).themeClassName = "Metadata";
    return value;
  }, [ctx, theme]);
  return (
    <ThemeProvider theme={themeValue}>
      <CssBaseline />
      <div className="Metadata">{props.children}</div>
    </ThemeProvider>
  );
};
const PageContentMenu: React.FC<{
  children: React.ReactNode;
}> = (props: { children: React.ReactNode }) => {
  const theme = useTheme();
  const ctx = useAppContext();
  const themeValue = React.useMemo(() => {
    const value = ((theme) => ({
      // KPIDetailsContent.KPIDetailsMenuContainer
      overrides: {
        MuiMenuItem: {
          root: {
            "&$selected": {
              // <-- mixing the two classes
              color: "#222 !important",
              "&:before": {
                content: '""',
                position: "relative",
                left: "0px",
                top: "0px",
                width: "8px",
                height: "8px",
                padding: "4px",
                borderRadius: "4px",
                transform: "scale(0.6)",
                background: "rgb(14,37,106)",
                marginRight: "5px",
                marginLeft: "5px",
              },
            },
            maxWidth: "auto",
            whiteSpace: "wrap",
            textAlign: "unset",
            backgroundColor: "rgba(0,0,0,0) !important",
            color: "#888",
            fontFamily: "Dubai",
            fontSize: "1.6em",
            "&:before": {
              content: '""',
              position: "relative",
              left: "0px",
              top: "0px",
              width: "8px",
              height: "8px",
              padding: "4px",
              borderRadius: "4px",
              transform: "scale(0.6)",
              background: "none",
              marginRight: "5px",
              marginLeft: "5px",
            },
          },
        },
      },
      qpr: {
        KPIDetailsContent: {
          KPIDetailsMenuContainer: {
            css: {
              marginTop: "10vh",
              position: "fixed",
              zIndex: 1000,
              width: "100%",
              maxWidth: "15%",
            },
          },
        },
      },
    }))();
    (value as any).themeClassName = "PageContentMenu";
    return value;
  }, [ctx, theme]);

  return (
    <ThemeProvider theme={themeValue}>
      <CssBaseline />
      <div className="PageContentMenu">{props.children}</div>
    </ThemeProvider>
  );
};

const useSideMenuStyles = (props: any) =>
  makeThemedStyles("", (theme) => ({
    drawer: {
      position: "relative",
      borderRadius: 0,
      borderTop: "none",
      borderBottom: "none",
      fontSize: "1.5rem",
      "& .MuiDrawer-paper": {
        position: "relative",
        top: 0,
      },
    },
    openMenu: {
      transition: "width .5s linear",
      padding: "10px",
      marginTop: "-34px",
      width: props.hierarchyMode === "Scorecards" ? "360px" : "300px",
      height: `100%`,
      paddingRight: "12px",
      overflowX: "hidden",

      "& .separator": {
        animationName: props.doOpeningAnimation ? "$AnimateOpenModelBtn" : "",

        animationDuration: ".5s",
        width: "90%",
        borderBottom: "1px solid #d3d3d382",
        margin: "auto",
      },
      "& .modelBtn": {
        animationName: props.doOpeningAnimation ? "$AnimateOpenModelBtn" : "",
        animationDuration: ".5s",
        animationTimingFunction: "ease-out",
        zIndex: 1,
        display: "flex",
        justifyContent: "space-between",
        alignContent: "center",
        alignItems: "center",
        position: "relative",
        cursor: "pointer",
        padding: "26px 10px",
        "& .modelName": {
          position: "relative",
          "& h3": {
            transition: "color .5s linear",
            zIndex: "2",
            marginBottom: "-4px",
            color: "rgb(14,37,106)",
            position: "relative",
            whiteSpace: "nowrap",
            "& svg": {
              display: "none",
            },
          },
        },
        "& .highlightArea": {
          transition: "width .5s linear",
          animationDuration: ".5s",
          animationName: "$fromCategoryToModelBtn",
          top: "-6px",
          insetInlineStart: "-20px",
          width: props.hierarchyMode === "Scorecards" ? "360px" : "300px",
          height: "190%",
          zIndex: "1",
          position: "absolute",
          background: "rgba(144,202,249,.12)",
          "& div": {
            width: "2px",
            height: "100%",
            background: "#115e67",
          },
        },
        "& .modelBtnIcon": {
          color: "#20b4af",
          fontSize: "30px",
        },
      },
      "& .data": {
        paddingInlineStart: "24px",
        borderInlineStart: "1px solid rgba(0, 0, 0, 0.1)",
        "& .subtitle": {
          fontFamily: "'Dubai'",
          fontStyle: "normal",
          fontWeight: "500",
          fontSize: "10px",
          lineHeight: "17px",
          letterSpacing: "0.846552px",
          textTransform: "uppercase",
          color: "#4C5157",
          opacity: "0.7",
          marginBottom: "0",
        },
      },
      "& .no-highlight": {
        animationName: props.doOpeningAnimation ? "$AnimateOpenModelBtn" : "",
        animationDuration: ".5s",
        "& .modelName h3": {
          color: "rgb(14,37,106) !important",
        },
        "& .modelBtn .highlightArea": {
          display: "none !important",
        },
      },
      "& .category-open": {
        animationName: `$fromModelBtnToCategoryColor , ${
          props.doOpeningAnimation ? "$AnimateOpenModelBtn" : ""
        }`,
        animationDuration: ".5s",
        padding: "20px",
        position: "relative",
        "& .categoryTitle": {
          zIndex: "3",
          position: "relative",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "10px",
          marginLeft: "-12px",
          "& h3": {
            margin: "0",
            fontWeight: "500",
            fontSize: "14px",
            color: "black",
          },
          "& svg": {
            color: "rgb(14,37,106)",
            fontSize: "20px",
            marginRight: "-12px",
          },
        },
        "& .highlightArea": {
          animationName: "$fromModelBtnToCategoryHighlightArea",
          animationDuration: ".5s",
          top: "0",
          insetInlineStart: "-32px",
          width: "400px",
          height: "100%",
          zIndex: "1",
          position: "absolute",
          background: "rgba(144,202,249,.2)",
          "& div": {
            width: "2px",
            height: "100%",
            marginLeft: 0,
            background: "rgba(14,37,106,.8)",
            zIndex: "2",
            position: "relative",
          },
        },
        "& .items": {
          position: "relative",
          zIndex: "3",
          paddingInlineStart: "15px",
          borderInlineStart: "1px solid rgba(0, 0, 0, 0.1)",
          "& .subtitle": {
            marginBottom: "revert-layer",
          },
          "& div": {
            position: "relative",
            marginBottom: "16px",
            "& .highlightArea": {
              position: "absolute !important",
              insetInlineStart: "-15px",
            },
            "& span": {
              width: "100%",
              fontSize: "1.3rem",
              cursor: "pointer",
            },
            "& span:hover": {
              textDecoration: "underline",
            },
          },
        },
      },
      "& .category-closed": {
        animationName: props.doOpeningAnimation ? "$AnimateOpenModelBtn" : "",
        animationDuration: ".5s",
        padding: "16px 10px",
        cursor: "pointer",
        zIndex: "1",
        position: "relative",
        "& .dimmed": {
          color: "#4C5157",
        },

        "&:hover": {
          "& .hoverArea": {
            background: "#f2f3f6",
          },
        },
        "& .hoverArea": {
          position: "absolute",
          width: "400px",
          height: "90%",
          top: "5%",
          insetInlineStart: "-25px",
          zIndex: "2",
        },

        "& .categoryTitle": {
          position: "relative",
          display: "flex",
          justifyContent: "space-between",
          alignContent: "center",
          alignItems: "center",
          zIndex: "3",
          fontWeight: "400",
          fontSize: "14px",
          "& span": {
            width: "85%",
          },
          "& svg": {
            color: "rgb(14,37,106)",
            fontSize: "12px",
          },
        },
      },
    },
    closedMenu: {
      transition: "width .5s linear",
      minWidth: "68px",
      maxWidth: "85px",
      height: "100%",
      fontSize: "1.5rem",
      background: "white",
      paddingLeft: props.isRtl ? "0" : "10px",
      paddingRight: props.isRtl ? "10px" : "0px",
      paddingTop: "10px",
      "& .modelBtn": {
        width: "50px",
        animationName: "$AnimateCloseModelBtn",
        animationDuration: ".5s",
        position: "relative",
        padding: "10px",
        cursor: "default",
        height: "fit-content",
        maxHeight: "calc(100vh - 180px)",
        overflowY: "hidden",
        "& h3": {
          color: "rgb(14,37,106)",
          display: "flex",
          zIndex: "2",
          position: "relative",
          alignItems: "center",
          writingMode: "vertical-lr",
          justifyContent: "center",
          direction: "ltr",
          fontStyle: "normal",
          fontWeight: "500",
          fontSize: "16px",
          margin: "16px 0",
          "& span": {
            maxHeight: "calc(100vh - 250px)",
          },
          "& svg": {
            marginTop: "10px",
            fontSize: "22px",
            color: "rgb(14,37,106)",
          },
        },
        "& .highlightArea": {
          animationName: "$AnimateCloseModelBtnHighlightArea",
          animationDuration: ".5s",
          zIndex: "1",
          position: "absolute",
          background: "rgb(233,244,254)",
          width: "100%",
          height: "100%",
          top: "0",
          insetInlineStart: "0px",
          borderRadius: "25px",

          "& div": {
            display: "none",
          },
        },
      },
      "& .modelBtnIcon, .separator, .category-closed, .category-open": {
        display: "none",
      },
    },
    closedMenuText: {
      transform: props.isRtl ? "scale(-1, -1)" : "",
    },
    "@keyframes AnimateCloseModelBtn": {
      "0%": {
        width: "203px",
        transform: "translate(78px,-76px) rotate(-90deg)",
      },
      "50%": {
        width: "90px",
      },
      "100%": { transform: "none", width: "50px" },
    },
    "@keyframes AnimateCloseModelBtnHighlightArea": {
      "0%": {
        borderEndEndRadius: "25px",
        borderEndStartRadius: "25px",
      },
      "100%": { borderRadius: "25px" },
    },
    "@keyframes AnimateOpenModelBtn": {
      // '0%': {
      //   transform: `translate(${props.isRtl ? '29px' : '-29px'},128px) rotate(90deg)`,
      //   width: '223px'
      // },
      // '50%': { transform: 'translateX(10px) ' },
      // '100%': { transform: 'none', width: 'auto', height: 'auto' }
    },
    "@keyframes AnimateOpenOpacity": {
      from: { opacity: 0 },
      to: { opacity: 1 },
    },
    "@keyframes fromModelBtnToCategoryColor": {
      from: { color: "black" },
      to: { color: "white" },
    },
    "@keyframes fromModelBtnToCategoryHighlightArea": {
      from: {
        opacity: "0",
      },
      to: {
        opacity: "1",
      },
    },
    "@keyframes fromCategoryToModelBtn": {
      from: {
        opacity: "0",
      },
      to: {
        opacity: "1",
      },
    },
  }));

export default { Metadata, PageContentMenu };
export { useSideMenuStyles };
